class AdvanceFiltersStep extends HTMLElement {
    static observedAttributes = ['data-active-index'];

    constructor() {
        super();
    }

    connectedCallback() {
        this.formInstance = customElements.get('advance-facet-filters-form');
        this.steps = this.querySelectorAll('div[data-step-index]');
        this.activeStep = this.querySelector('div[data-step-index]:not(.visually-hidden)');
        this.backNavigation = this.querySelectorAll('button.js_previous_step');
        this.searchInputs = this.querySelectorAll('input[type="search"].js-step-search ');

        this.searchActiveFields = this.querySelectorAll('div[data-step-index]:not(.visually-hidden) li[data-search]');

        this.setListeners();
    }
    attributeChangedCallback(name, oldValue, newValue) {
        switch (name) {
            case 'data-active-index': {
                if (!oldValue || !newValue) return;

                // Visually switch step
                this.activeStep?.classList.toggle('visually-hidden');
                const nextActiveStep = this.querySelector(`div[data-step-index="${newValue}"]`);
                nextActiveStep?.classList.toggle('visually-hidden');
                // Update reset value in case of filter change on previous step
                const nextResetParam = nextActiveStep?.getAttribute('data-filter-param');
                this.updateResetParam(nextResetParam ? nextResetParam : null);
                const resetParam = this.activeStep?.getAttribute('data-filter-param');
                this.updateResetParam(resetParam ? resetParam : null);
                // Update active step
                this.activeStep = nextActiveStep;
                // Update active field for search
                this.searchActiveFields = this.activeStep?.querySelectorAll('li[data-search]');

                break;
            }
        }
    }

    setListeners() {
        // Navigation buttons listener
        this.backNavigation?.forEach((backButton) => {
            backButton.addEventListener('click', this.onBackButtonClickHandler.bind(this));
        });
        // Search bars
        this.searchInputs?.forEach((bar) => {
            bar.addEventListener('input', this.onSearchBarInputHandler.bind(this));
        });
    }

    onBackButtonClickHandler() {
        const currentIndex = this.getCurrentIndex();
        if (currentIndex) {
            const prevIndex = parseInt(currentIndex, 10) - 1;
            this.setCurrentIndex(prevIndex.toFixed(0));
        }
        const activeFilter = this.activeStep?.querySelector('.facets__label.active input');
        if (activeFilter) {
            this.formInstance.toggleLoadingState(true);
            activeFilter.click();
        }
    }

    onSearchBarInputHandler(event) {
        event.stopPropagation();
        const { value } = event.target;

        if (value.length <= 2) {
            this.searchActiveFields?.forEach(this.showField);
            const activeUl = this.activeStep?.querySelector('ul.facets-layout-list');
            if (activeUl) activeUl.classList.remove('searching');
        } else {
            const filter = value.toLowerCase();
            this.searchActiveFields?.forEach((field) => {
                const attr = field.getAttribute('data-search');
                if (attr?.toLowerCase().includes(filter)) this.showField(field);
                else this.hideField(field);
            });
            const activeUl = this.activeStep?.querySelector('ul.facets-layout-list');
            if (activeUl) activeUl.classList.add('searching');
        }
    }

    hideField(field) {
        field.classList.add('d-none');
        field.classList.remove('d-flex');
    }
    showField(field) {
        field.classList.add('d-flex');
        field.classList.remove('d-none');
    }

    getCurrentIndex() {
        return this.getAttribute('data-active-index');
    }

    setCurrentIndex(index) {
        this.setAttribute('data-active-index', index);
    }

    updateResetParam(param = null) {
        if (!param) this.setAttribute('data-filter-reset', '');
        // TOO: params should be an array ?
        // manage the case where there is already the param stored in the attr ?
        else {
            const prevParams = this.getAttribute('data-filter-reset');
            let newParams = param;
            if (prevParams?.length > 0) newParams = prevParams + ',' + param;

            this.setAttribute('data-filter-reset', newParams);
        }
    }
}
customElements.define('advance-filters-step', AdvanceFiltersStep);
